import React from 'react';

import { FormattedMessage } from 'react-intl';

import { cssMap, cx } from '@atlaskit/css';
import { Box, Flex } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { messages } from './messages';

const styles = cssMap({
	footer: {
		paddingBlock: token('space.600'),
		textAlign: 'center',
		whiteSpace: 'nowrap',
		backgroundColor: token('elevation.surface'),
		borderTopWidth: token('border.width'),
		borderTopStyle: 'solid',
		borderTopColor: token('color.border'),
	},
	content: {
		color: token('color.text.subtlest'),
	},
});

export const Footer = (): React.JSX.Element => {
	return (
		<Box as="footer" xcss={cx(styles.footer)} testId="hub-footer">
			<Flex justifyContent="center" alignItems="center" gap="space.050">
				<Box xcss={cx(styles.content)}>
					<FormattedMessage {...messages.footer} />
				</Box>
			</Flex>
		</Box>
	);
};
